import styled from "styled-components";

const HEADER_FOOTER_PADDING = "16px 24px";

export interface WrapperProps {
  $width?: number | string;
}

const resolveWidth = (w?: number | string) =>
  typeof w === "number" ? `${w}px` : (w ?? "100%");

export const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-direction: column;
  width: ${({ $width }) => resolveWidth($width)};
  max-width: 100%;
  height: 100%;
  max-height: 100%;
  background: #f6f6f7;
  border-radius: 8px;
  overflow: hidden;
`;

export const Header = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${HEADER_FOOTER_PADDING};
  background: #fff;
  border-bottom: 1px solid #c5c6ca;
`;

export const Title = styled.h3`
  margin: 0;
  flex: 1 0 0;
  min-width: 0;
  font-family: Lato, sans-serif;
  font-weight: 900;
  font-size: 20px;
  line-height: 28px;
  color: #19191b;
`;

export const CloseButtonSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
`;

export const ProgressBar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: #fffbe8;
  overflow: hidden;
`;

interface ProgressBarFillProps {
  $value: number;
}

export const ProgressBarFill = styled.div<ProgressBarFillProps>`
  height: 100%;
  width: ${({ $value }) => $value}%;
  background: #fecf00;
  transition: width 200ms ease;
`;

export const Body = styled.div`
  flex: 1 0 0;
  min-height: 0;
  overflow-y: auto;
`;

export const Footer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: ${HEADER_FOOTER_PADDING};
  background: #fff;
  border-top: 1px solid #c5c6ca;
`;

// Left of the footer: the secondary (e.g. Back) and destructive actions.
export const FooterStartGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

// Optional content shown just before the primary action (e.g. a total).
export const FooterStartSlot = styled.div`
  display: flex;
  align-items: center;
`;

// Right of the footer: optional footerStart content + the primary action.
export const ActionsSlot = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-xxl, 40px);
`;
